class LcTrustBadges extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (window.FoxTheme && window.FoxTheme.Motion && typeof window.FoxTheme.Motion.inView === 'function') {
      window.FoxTheme.Motion.inView(this, this.init.bind(this));
    } else {
      this.init();
    }
  }
  init() {
    if (this.animated) return;
    this.animated = true;
    this.classList.add('lc-animate');
    const elements = this.querySelectorAll('.lc-trust-badges__circle-text');
    elements.forEach(element => {
      const text = element.textContent.trim();
      const match = text.match(/^(\d+)(.*)$/);
      if (!match) return;
      const targetValue = parseInt(match[1], 10);
      const suffix = match[2] || '';
      const duration = 1500;
      const startTime = performance.now();
      const animate = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const easeProgress = 1 - Math.pow(1 - progress, 4);
        const currentValue = Math.floor(easeProgress * targetValue);
        element.textContent = `${currentValue}${suffix}`;
        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          element.textContent = text;
        }
      };
      element.textContent = `0${suffix}`;
      requestAnimationFrame(animate);
    });
  }
}
customElements.define('lc-trust-badges', LcTrustBadges);
